import React from "react";

export default function Footer() {
    return (
        <footer>
            <div className="wrap">
                <div className="btm-text">
                    <p>졸업설계 프로젝트</p>
                    {/* Footer logo intentionally hidden until a real asset is needed. */}
                </div>
            </div>
        </footer>
    );
}
